<template>
  <div class="upload-vdo">
    <div class="upload-btn">
      Upload Video
      <input type="file" @change="uploadItem" class="input_file" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'UploadVideo',
  data() {
    return {
      uploadItem: [],
    };
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/upload.scss';
</style>
